import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import { Link as GgLink } from '@gogame/components';

const ScreenGo = ({ to, children, ...props }) => {
  const { search } = useLocation();
  return (
    <GgLink component={RouterLink} to={`${to}${search}`} {...props}>
      {children}
    </GgLink>
  );
};

export default ScreenGo;
